/** react-select styles shared by the mobile agenda filters. */
export type MobileSelectOption = { value: string | number; label: string };

export const mobileSelectStyles = {
  control: (base: Record<string, unknown>, state: { isFocused: boolean }) => ({
    ...base,
    minHeight: 48,
    height: 48,
    borderRadius: 12,
    borderColor: state.isFocused ? "#3182CE" : "#D9E2EC",
    backgroundColor: state.isFocused ? "#FFFFFF" : "#F8FAFC",
    boxShadow: state.isFocused
      ? "0 0 0 3px rgba(49,130,206,0.15)"
      : "0 1px 2px rgba(15,23,42,0.06)",
    fontFamily: "inherit",
    cursor: "pointer",
  }),
  valueContainer: (base: Record<string, unknown>) => ({
    ...base,
    padding: "0 12px",
  }),
  singleValue: (base: Record<string, unknown>) => ({
    ...base,
    color: "#2D3748",
    fontSize: 14,
    fontWeight: 600,
    fontFamily: "inherit",
  }),
  placeholder: (base: Record<string, unknown>) => ({
    ...base,
    color: "#64748B",
    fontFamily: "inherit",
  }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base: Record<string, unknown>) => ({
    ...base,
    color: "#64748B",
    padding: "0 12px 0 4px",
  }),
  menu: (base: Record<string, unknown>) => ({
    ...base,
    marginTop: 6,
    borderRadius: 12,
    border: "1px solid #E2E8F0",
    boxShadow: "0 12px 28px rgba(15,23,42,0.14)",
    overflow: "hidden",
    fontFamily: "inherit",
    zIndex: 40,
  }),
  option: (base: Record<string, unknown>, state: { isFocused: boolean; isSelected: boolean }) => ({
    ...base,
    padding: "11px 13px",
    color: state.isSelected ? "#1D4ED8" : "#2D3748",
    backgroundColor: state.isSelected
      ? "#EBF4FF"
      : state.isFocused
        ? "#F7FAFC"
        : "#FFFFFF",
    fontSize: 14,
    fontWeight: state.isSelected ? 600 : 500,
    fontFamily: "inherit",
    cursor: "pointer",
  }),
  menuPortal: (base: Record<string, unknown>) => ({
    ...base,
    zIndex: 100,
  }),
};
